// english

export default {
  my_base_title: '我的信息',
  my_base_btn: '更新我的信息',

  // form
  my_form_username: '用户名',
  my_form_role: '角色',
  my_form_avatar: '头像',
  my_form_nickname: '昵称',
  my_form_nickname_placeholder: '请输入昵称',
  my_form_contact: '联系方式',
  my_form_contact_placeholder: '请输入联系方式',
  my_form_email: 'Email',
  my_form_email_placeholder: '请输入你的email地址',
  my_form_customer: '隶属客户',

  // email
  my_email_title: 'Email',
  my_email_tips: '一旦更改，与您的帐户关联的电子邮件将相应更改',
  my_email_btn: '更新我的Email',
  my_email_password_title: '验证登录密码',
  my_email_password: '密码',
  my_email_password_help: '请输入登录密码',

  // password
  my_password: '密码',
  my_password_help: '密码更改后，您需要使用新密码重新登录',
  my_password_current: '旧密码',
  my_password_current_placeholder: '请输入旧密码',
  my_password_new: '新密码',
  my_password_new_help: '密码必须为8-32位，包含大小字母、数字和特殊字符',
  my_password_new_placeholder: '请输入新密码',
  my_password_new_confirm: '确认新密码',
  my_password_new_confirm_placeholder: '请确认新密码',
  my_password_btn: '更新我的帐户密码',
  my_password_error1: '密码强度不够',
  my_password_error2: '两次密码输入不一致',
};
